import MuiButton from "@material-ui/core/Button";
import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import InfoTooltip from "Shared/InfoTooltip";
import styled from "styled-components";
import { AccountState } from "Types/state";
import { TradeIn } from "Types/TradeIn";
import TradePendingLogo from "../../../../icons/trade-pending.inline.svg";
import Remove from "../../../icons/Remove";
import "./TradePendingFooter.scss";

export const RemoveBtn = styled(MuiButton as any)`
    padding: 8px;
    text-transform: none !important;
    width: 100%;

    ${(props) => props.theme.breakpoints.up("desktop")} {
        width: 390px;
    }
`;

interface TradePendingFooterProps {
    account: AccountState;
    tradePending: TradeIn;
    uuid: string;
    resetTradePending: (uuid: string, reset: boolean) => void;
}

class TradePendingFooter extends React.Component<TradePendingFooterProps & WithTranslation> {
    public render() {
        const { tradePending, t, account } = this.props;
        const hasYMMTResult = !!tradePending.ymmt;
        const disclosureCopy =
            (account && account.account_disclaimers && account.account_disclaimers.global_trade_in) || "";
        const { make, model, trim, year } = tradePending;

        return (
            <div className="Footer__container">
                <div className="Footer__info">
                    <div className="Footer__info--tooltips">
                        <span className="Footer__tooltip">
                            <InfoTooltip className="Footer__tooltip--icon" icon="info" text={disclosureCopy} />
                            {t("TradePending.TradePendingFooter.disclosureLabel")}
                        </span>
                    </div>
                    <div className="Footer__info--logo">
                        <TradePendingLogo />
                    </div>
                </div>

                {/* TODO: maybe should show Remove no matter if its manual or not */}
                {hasYMMTResult && (
                    <div className="Footer__removeVehicle">
                        <RemoveBtn onClick={this.handleOnClick}>
                            <Remove className="Footer__removeVehicle--icon" />
                            <span className="Footer__removeVehicle--CTA">
                                {t("TradePending.TradePendingFooter.remove", { year, make, model, trim })}
                            </span>
                        </RemoveBtn>
                    </div>
                )}
            </div>
        );
    }

    protected handleOnClick = (event: any) => {
        this.props.resetTradePending(this.props.uuid, true);
    };
}

export default withTranslation()(TradePendingFooter);
